<template>
    <div v-if="scope.row[config.prop]">
       <a :href="scope.row[config.prop]">{{ scope.row[config.prop] }}</a>
    </div>
    <div v-else>
        无对应字段~
    </div>
</template>

<script>
export default {
    name: "THref",
    cName:'网址',
    // functional: true,
    // Props 是可选的
    props: ["scope", "config"],
    data() {
        return {};
    }
};
</script>
